import { render, staticRenderFns } from "./shopOrderDetail.vue?vue&type=template&id=74668a02&scoped=true"
import script from "./shopOrderDetail.vue?vue&type=script&lang=js"
export * from "./shopOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./shopOrderDetail.vue?vue&type=style&index=0&id=74668a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74668a02",
  null
  
)

export default component.exports